(function() {
  $(document).ready(function() {
    $('#select_msa').change(function() {
      window.location.href = '/legal/' + $(this).val();
    });
  });
})();
